type MapPreviewProps = {
  name: string;
  address: string;
  zip: string;
  mapEmbedUrl?: string;
  mapEmbedHtml?: string;
};

function getCoordinates(raw: string): [number, number] | null {
  const source = raw.match(/src=["']([^"']+)["']/i)?.[1] || raw;
  try {
    const url = new URL(source.replace(/&amp;/g, "&"));
    const pb = url.searchParams.get("pb") || "";
    const match = pb.match(/!2d(-?[\d.]+)!3d(-?[\d.]+)/);
    const pair = (url.searchParams.get("marker") || url.searchParams.get("ll") || url.searchParams.get("q") || "").split(",");
    const lat = Number(match ? match[2] : pair[0]);
    const lon = Number(match ? match[1] : pair[1]);
    if ((!match && (pair.length !== 2 || pair.some((part) => !part.trim()))) || !Number.isFinite(lat) || !Number.isFinite(lon) || Math.abs(lat) > 90 || Math.abs(lon) > 180) return null;
    return [lat, lon];
  } catch {
    return null;
  }
}

export default function MapPreview(center: MapPreviewProps) {
  const coordinates = getCoordinates(center.mapEmbedUrl || center.mapEmbedHtml || "");
  const googleUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${center.address}, ${center.zip}`)}`;
  let previewUrl: string | undefined;
  if (coordinates) {
    const [lat, lon] = coordinates;
    const params = new URLSearchParams({
      bbox: `${lon - 0.004},${lat - 0.0025},${lon + 0.004},${lat + 0.0025}`,
      layer: "mapnik",
      marker: `${lat},${lon}`,
    });
    previewUrl = `https://www.openstreetmap.org/export/embed.html?${params}`;
  }

  return (
    <div className="relative h-full w-full overflow-hidden bg-slate-100">
      {previewUrl && (
        <iframe
          src={previewUrl}
          title={`Mapa de ${center.name} en OpenStreetMap`}
          loading="lazy"
          referrerPolicy="no-referrer"
          tabIndex={-1}
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 h-full w-full border-0"
        />
      )}
      <a
        data-analytics="center/open-map"
        href={googleUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Abrir ${center.name} en Google Maps (nueva pestaña)`}
        className="absolute inset-0 flex items-start justify-end p-3 focus-visible:outline-4 focus-visible:-outline-offset-4 focus-visible:outline-blue-600"
      >
        <span className="rounded bg-white px-2 py-1 text-xs font-semibold text-slate-800 shadow">
          Abrir en Google Maps ↗
        </span>
      </a>
      <a
        href="https://www.openstreetmap.org/copyright"
        target="_blank"
        rel="noopener noreferrer"
        className="absolute bottom-0 right-0 bg-white px-1 text-[10px] text-slate-700 underline"
      >
        © OpenStreetMap contributors
      </a>
    </div>
  );
}
